
const pluginId = 'scaleLegendClick'

type legend = {
    scaleId: string
    label: string
}

interface legendCoordinates extends legend {
    coordinates: {
        x: number,
        x2: number,
        y: number,
        y2: number
    }
}

function getLegend(legends: Array<any>, pointer: any): legend | null {
    let returnValue: legend | null = null

    for (const legend of legends) {
        const coordinates = legend.coordinates
        if (
            pointer.x >= coordinates.x &&
            pointer.x <= coordinates.x2 &&
            pointer.y >= coordinates.y &&
            pointer.y <= coordinates.y2) {
            returnValue = {
                scaleId: legend.scaleId,
                label: legend.label
            }
            break
        }
    }
    return returnValue
}

function getLegendCoordinates(metaSets: Array<any>): Array<legendCoordinates> {
    return metaSets.map((metaSet: any) => {
        const scale = metaSet.yScale
        const options = scale.options
        return {
            scaleId: scale.id,
            label: options.title.text,
            coordinates: {
                x: scale.left,
                x2: scale.right,
                y: scale.top,
                y2: scale.bottom,
            }
        }
    })
}

function getOnClick(chart: any): any {
    return chart?.config?._config?.options?.plugins?.scaleLegendClick?.onClick
}

function afterEvent(chart: any, chartEvent: any, context: any): void {
    const event = chartEvent.event
    if (event.type !== 'click' || chartEvent?.inChartArea) return
    const onClick = getOnClick(chart)
    if (!onClick || typeof onClick !== 'function') return

    const legendCoordinates = getLegendCoordinates(chart._metasets)
    const legendInfo = getLegend(legendCoordinates, event);
    if (!!legendInfo) {
        onClick(legendInfo, context)
    }
}

export const scaleLegendClick = {
    id: pluginId,
    afterEvent: afterEvent
}
